window.EmailOtpVerificationForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            textBox:{
                verificationCode:'#email-otp-verify-verification-code',
                otpModelId:'#otp-modelId'
            },
            link:{
              sentOtp:'#email-otp-verify-send-otp'
            },
            button: {
                triggerVerify: '#email-otp-verify-trigger-verify',
            },
            form:{
                phoneNumberForm:'#email-otp-verify-form'
            }
        },
        urls: {
            sendOtpToEmailUrl:'/api/sitecore/UpdateMemberZonePhoneNumber/TriggerOtpToEmail',
            sendOtpToPhoneUrl:'/api/sitecore/UpdateMemberZonePhoneNumber/TriggerOtpToPhone',
            verifyOtpUrl:'/api/sitecore/UpdateMemberZonePhoneNumber/VerifyOtp',
            phoneOtpVerificationPageUrl : '/my-account/details/phone/update-memberzone-phone-number/phone-number-otp-verification',
            errorPageUrl: '/error/error-page'
        },
        statusDescription: {
            accepted: 'accepted',
            successful: 'ok'
        },
        constants: {
            CharCodeUnitSeparator: 31,
            CharCodeLowerBound: 48,
            CharCodeUpperBound: 57,
            InputCodeLength: 4,
            AccountEmail: 'AccountEmail',
            DigitsOnlyRegex: /[^0-9]/g
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.link.sentOtp).on('click', self.func.sentOtpToEmail);
                $(self.elements.textBox.verificationCode).on('keypress', self.func.allowNumbersOnly);
                $(self.elements.textBox.verificationCode).on('paste', self.func.allowPastingOfNumbers);
                $(self.elements.button.triggerVerify).on('click',self.func.verifyOtp);
            },
            sentOtpToEmail: function (event) {
                event.preventDefault();
                $.ajax({
                    type: 'PATCH',
                    url: self.urls.sendOtpToEmailUrl,
                    success: function(response) {
                        if(response.statusCode?.toLowerCase() === self.statusDescription.accepted) {
                            const modelId = $(self.elements.textBox.otpModelId).val().trim();
                            window.openModal(modelId);
                        }
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            sentOtpToPhone: function () {
                $.ajax({
                    type: 'PATCH',
                    url: self.urls.sendOtpToPhoneUrl,
                    success: function(response) {
                        const isAccepted = response.statusCode?.toLowerCase() === self.statusDescription.accepted;
                        window.location.href = isAccepted ? self.urls.phoneOtpVerificationPageUrl : self.urls.errorPageUrl;
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            verifyOtp: function (event) {
                event.preventDefault();
                const details = {
                    Code: $(self.elements.textBox.verificationCode).val().trim(),
                    AccountAttribute: self.constants.AccountEmail
                };
                $.ajax({
                    type: 'POST',
                    url: self.urls.verifyOtpUrl,
                    data: details,
                    success: function(response) {
                        if(response.statusCode?.toLowerCase() === self.statusDescription.successful) {
                            self.func.sentOtpToPhone();
                        }
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            allowNumbersOnly: function (event) {
                const charCode = event.charCode || event.keyCode;
                const isControlCode = charCode <= self.constants.CharCodeUnitSeparator;
                const isNumericCode = charCode >= self.constants.CharCodeLowerBound &&
                    charCode <= self.constants.CharCodeUpperBound;
                if (!isControlCode && !isNumericCode) {
                    event.preventDefault();
                    return false;
                }
            },
            allowPastingOfNumbers: function (event) {
                event.preventDefault();
                let clipData = event.originalEvent.clipboardData.getData('text');
                if (clipData) {
                    event.target.value = clipData
                        .replace(self.constants.DigitsOnlyRegex, '')
                        .slice(0, self.constants.InputCodeLength);
                }
            },
        }
    };

    return {
        Init: self.func.init
    };
}) ();

$(document).ready(function () {
    if ('email-otp-verify-form' === $('#email-otp-verify-form').data('feature')) {
        window.EmailOtpVerificationForm.Init();
    }
});
